<template>
    <v-flex class="share-block" v-if="isCurrentUser">
        <v-layout row wrap  class="share-block-row">
            <v-flex xs7>
                <v-flex tag="span">{{memberProfileConstants.DEFAULT_EDIT_TEXT.SHARE_SOMETHING}}</v-flex>
            </v-flex>
            <v-flex xs5 text-xs-right>
                <i class="fas fa-image"></i>
                <v-btn depressed class="primary_btn" data-qe-id="share_btn" id="share_btn">{{memberProfileConstants.SHARE}} </v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { memberProfileConstants } from "./memberProfile.constants.js";

    export default {
        name: "Share",
        data: () => ({
            memberProfileConstants,
        }),
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        computed: {
            isCurrentUser() {
                return this.memberId === this.$parent.currentUserId;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .share-block {
        background: rgba($ypo-prospect-tile-border, 0.4);
        box-shadow: 0 0 3px 0 rgba($black, 0.5);
        border-radius: 4px;
        padding: 15px;
        margin: 0 0 25px 0;
        

        .share-block-row {
            background: $white;
            box-shadow: 0 0 3px 0 rgba($black, 0.5);
            border-radius: 4px;
            cursor: pointer;

            span {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                display: block;
                padding: 15px 0 0 10px;
            }
            i{
                color: #44779F;
    font-size: 22px;
    position: relative;
    top: 5px;
            }
        }
    }
</style>
